'use strict';
/**
 * Collection of input elements
 * as the <input> (or <select> or whatever) element is nested inside the returned HTMLElement,
 * use form's namedItem to access data :
 * formElement["id"]
 * formElement.namedItem("id");
 * in case you don't set the ID yourself or you're not inside a form (?!) :
 * `elem.firstChild.value` should do the trick.
 */
import {makeElement, span, div, input} from "../utils/makeElement";

const label = makeElement.bind(null, "label");

let idCount = 0;

function uid(id){
  return (id?id:`input-${idCount++}`);
}

// opts :
// id: string, unique Identifier
// title: string, input title
// label: object, label custom properties
// input: object, input custom properties
export function inputText(opts){
  return span({
    id: opts.id,
    className: `float-label ${(opts.className?" "+opts.className:"")}`
  },[
    input(Object.assign({
      id: uid(opts.id),
      type: "text",
      className: "input-field input-text",
    }, opts.input)),
    label(Object.assign({
      for:uid(opts.id)
    }, opts.label), opts.title)
  ])
}

// Allow to create visually OK files list in a form
// Return a function to be used for later update
export function fileList({title, files}){
  const txtField = span({className:"input-field filenames"},Array.isArray(files)? files.join(", "): "");
  const elem = div({className: "float-label"}, [
    txtField,
    span({className:"label"}, title)
  ])
  return  function updateFileList(list){
    if(!Array.isArray(list)) throw new Error("expected list to be an array, got "+ typeof list);
    txtField.textContent = list.join(", ");
    txtField.title = list.join(", ");
    return elem; //Always return elem
  }
}

// opts :
// id : string, unique identifier
// title: string, select title
// label: object, custom label properties
// children: Array of string or object like :
// {title: "string", value: "string"}
export function inputSelect(opts){
  let id = opts.id || Math.random.toString(16);
  if(!Array.isArray(opts.children)) {
    throw new Error("Expect opts.children to be an array, got"+typeof opts.children);
  }
  //Sometimes we want value === title and we just give strings as children
  let children = opts.children.map((c)=>{
    return ((typeof c === "object") ?  c : {title: c, value: c});
  })
  return span({
    className: "float-label select-box"
  },[
    makeElement("select",
      Object.assign({
        id : uid(opts.id),
        dataset: {value: children[0].value},
      }, opts.select),
      children.map(({title, value}) => makeElement("option",{value: value}, title))
    ),
    label(Object.assign({
      for:uid(opts.id)
    }, opts.label), opts.title)
  ])
}
